import router from '@/router'
import { notification } from 'ant-design-vue'
import { authAPI } from '@/services/axios/perki'
import VueCookies from 'vue-cookies'
import apiClient from '../../services/axios/perki/index'

export default {
  namespaced: true,
  state: {
    id: '',
    name: '',
    role: '',
    email: '',
    avatar: '',
    groupId: '',
    group: '',
    groupCategory: '',
    authorized: false,
    loading: false,
    accountFetchIsTouched: false,
  },
  mutations: {
    SET_STATE(state, payload) {
      Object.assign(state, {
        ...payload,
      })
    },
  },
  actions: {
    async LOGIN({ commit, dispatch, rootState }, { email, password }) {
      try {
        const response = await authAPI.login({
          email,
          password,
        })

        console.log('Login response:', response.data)

        const { user, token } = response.data.result

        const dataUser = {
          user: {
            name: user.name || user.fullName,
            role: user.role,
            email: user.email,
            accessToken: token,
            group: user.group,
            groupId: user.groupId,
          },
          sessionId: token,
        }

        localStorage.setItem('userData', JSON.stringify(dataUser))
        localStorage.setItem('perki_token', token)
        localStorage.setItem('perki_user', JSON.stringify(user))

        return new Promise((resolve, reject) => {
          resolve({ user: dataUser.user, session: token })
        })
      } catch (err) {
        console.error('Login error in store:', err)
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async LOAD_CURRENT_ACCOUNT({ commit, dispatch, rootState }, { token }) {
      try {
        // const perkiToken = localStorage.getItem('perki_token')
        console.log(token, '<<<DISINI CEK TOKEN NYA ANJIR')
        const outerData = await apiClient.get('/users/load?token=' + token)
        if (!outerData) router.push('/masuk')
        // // console.log(outerData, 'outerData')
        const user = outerData.data.result.userData
        console.log(user, 'user')
        // const dataUser = {
        //   user: {
        //     name: user.name || user.fullName,
        //     role: user.role,
        //     email: user.email,
        //     accessToken: token,
        //     group: user.group?.code,
        //     groupId: user.groupId,
        //     groupCategory,
        //   },
        //   sessionId: token,
        // }
        console.log(user.groupCategory, '<<< USERNYA')
        commit('SET_STATE', {
          name: user.name,
          email: user.email,
          sessionId: token,
          id: user.id,
          groupId: user.groupId,
          group: user.group,
          groupCategory: user.groupCategory,
          gender: user.gender,
          role: user.role,
        })
        VueCookies.set(
          'user',
          {
            name: user.name,
            email: user.email,
            sessionId: token,
            id: user.id,
            id: user.groupId,
            group: user.group,
            groupCategory: user.groupCategory,
            gender: user.gender,
            role: user.role,
          },
          null,
          '/',
        )
        // return new Promise((resolve, reject) => {
        //   resolve()
        // })
      } catch (err) {
        // router.push('/masuk')
        // console.log(err)
        // return new Promise((resolve, reject) => {
        //   reject(err)
        // })
      }
    },
    async LOGOUT({ commit, rootState }) {
      try {
        // await apiClient.post('/account/logout')
        VueCookies.remove('sessionId')
        VueCookies.remove('user')
        localStorage.clear()
        commit('SET_STATE', {
          id: '',
          name: '',
          role: '',
          email: '',
          avatar: '',
          authorized: false,
          loading: false,
          accountFetchIsTouched: false,
        })
        router.push('/masuk')
      } catch (err) {
        console.log(err)
      }
    },
  },
  getters: {
    user: state => state,
  },
}
